/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Regenerate_Instructions_P2Inputs */

const en_two_fa_regenerate_instructions_p2 = /** @type {(inputs: Two_Fa_Regenerate_Instructions_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please delete the old code in your authenticator app and scan the new QR code.`)
};

const nl_two_fa_regenerate_instructions_p2 = /** @type {(inputs: Two_Fa_Regenerate_Instructions_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijder de oude code in je authenticator-app en scan de nieuwe QR-code.`)
};

/**
* | output |
* | --- |
* | "Please delete the old code in your authenticator app and scan the new QR code." |
*
* @param {Two_Fa_Regenerate_Instructions_P2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_regenerate_instructions_p2 = /** @type {((inputs?: Two_Fa_Regenerate_Instructions_P2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Regenerate_Instructions_P2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_regenerate_instructions_p2(inputs)
	return en_two_fa_regenerate_instructions_p2(inputs)
});